<div class="exam-container">
  <!-- Loading State -->
  @if (isLoading()) {
    <div class="loading-screen">
      <div class="spinner-large"></div>
      <p class="loading-text">Cargando examen...</p>
    </div>
  }

  <!-- Historial de intentos (cuando ya no hay intentos disponibles) -->
  @else if (mostrarHistorialIntentos() && examen()) {
    <div class="history-screen">
      <div class="history-card">
        <button class="btn-back" (click)="goBack()">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M8 16L2 10L8 4M2 10H18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          Volver
        </button>

        <div class="history-header">
          <div class="header-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none">
              <path d="M9 11L12 14L22 4" stroke="#0e40d8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M21 12V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16" stroke="#0e40d8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          
          <h1 class="history-title">Historial de Intentos</h1>
          <p class="history-subtitle">Has completado todos los intentos disponibles para este examen</p>

          <div class="exam-info-summary">
            <div class="info-row">
              <span class="info-label">Examen:</span>
              <span class="info-value">{{ examen()!.titulo }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">Total de intentos:</span>
              <span class="info-value">{{ todosLosIntentos().length }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">Intentos permitidos:</span>
              <span class="info-value">{{ examen()!.intentos_permitidos }}</span>
            </div>
          </div>

          @if (getBestAttempt(); as bestAttempt) {
            <div class="best-attempt-banner">
              <div class="best-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor" stroke="currentColor" stroke-width="2"/>
                </svg>
              </div>
              <div class="best-content">
                <div class="best-label">Mejor Resultado</div>
                <div class="best-score">{{ bestAttempt.porcentaje }}%</div>
                <div class="best-details">
                  Intento {{ bestAttempt.numero_intento }} • {{ bestAttempt.puntos_obtenidos }}/{{ bestAttempt.puntos_totales }} puntos
                </div>
              </div>
            </div>
          }
        </div>

        <div class="attempts-section">
          <h2 class="attempts-title">Todos tus intentos</h2>
          
          <div class="attempts-grid">
            @for (intento of todosLosIntentos(); track intento.id_intento) {
              <div class="attempt-item" [class.passed]="intento.aprobado" [class.failed]="!intento.aprobado">
                <div class="attempt-top">
                  <div class="attempt-left">
                    <div class="attempt-badge">Intento {{ intento.numero_intento }}</div>
                    <div class="attempt-status" [class.status-passed]="intento.aprobado" [class.status-failed]="!intento.aprobado">
                      @if (intento.aprobado) {
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                          <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        Aprobado
                      } @else {
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                        No Aprobado
                      }
                    </div>
                  </div>

                  <div class="attempt-score-badge" [class.passed]="intento.aprobado" [class.failed]="!intento.aprobado">
                    {{ intento.porcentaje }}%
                  </div>
                </div>

                <div class="attempt-stats">
                  <div class="stat">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                      <path d="M12 6V12L16 14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                    <div class="stat-info">
                      <span class="stat-label">Tiempo</span>
                      <span class="stat-value">{{ formatAttemptTime(intento.tiempo_transcurrido) }}</span>
                    </div>
                  </div>

                  <div class="stat">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M9 11L12 14L22 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M21 12V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <div class="stat-info">
                      <span class="stat-label">Puntos</span>
                      <span class="stat-value">{{ intento.puntos_obtenidos }}/{{ intento.puntos_totales }}</span>
                    </div>
                  </div>
                </div>

                <div class="attempt-date">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2"/>
                    <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="2"/>
                  </svg>
                  {{ formatAttemptDate(intento.fecha_finalizacion) }}
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }

  <!-- Pantalla de instrucciones (antes de iniciar) -->
  @else if (!examenIniciado() && examen() && !examenFinalizado() && !mostrarHistorialIntentos()) {
    <div class="instructions-screen">
      <div class="instructions-card">
        <div class="exam-header">
          <button class="btn-back" (click)="goBack()">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M8 16L2 10L8 4M2 10H18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Volver
          </button>
          
          <div class="exam-icon-header">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
              <rect x="8" y="6" width="32" height="36" rx="2" stroke="#0e40d8" stroke-width="2"/>
              <line x1="14" y1="14" x2="34" y2="14" stroke="#0e40d8" stroke-width="2" stroke-linecap="round"/>
              <line x1="14" y1="22" x2="34" y2="22" stroke="#0e40d8" stroke-width="2" stroke-linecap="round"/>
              <line x1="14" y1="30" x2="26" y2="30" stroke="#0e40d8" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </div>
        </div>

        <h1 class="exam-title">{{ examen()!.titulo }}</h1>
        <p class="exam-description">{{ examen()!.descripcion }}</p>

        <div class="exam-stats">
          <div class="stat-item">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 8V12L15 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2"/>
            </svg>
            <div class="stat-content">
              <span class="stat-label">Tiempo límite</span>
              <span class="stat-value">
                @if (examen()!.tiempo_limite && examen()!.tiempo_limite > 0) {
                  {{ examen()!.tiempo_limite }} minutos
                } @else {
                  Sin límite
                }
              </span>
            </div>
          </div>

          <div class="stat-item">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2"/>
              <path d="M9 9H15M9 13H15M9 17H12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <div class="stat-content">
              <span class="stat-label">Preguntas</span>
              <span class="stat-value">{{ examen()!.preguntas.length }} preguntas</span>
            </div>
          </div>

          <div class="stat-item">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M9 11L12 14L22 4M21 12V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <div class="stat-content">
              <span class="stat-label">Nota mínima</span>
              <span class="stat-value">{{ examen()!.nota_minima_aprobacion }}%</span>
            </div>
          </div>

          <div class="stat-item">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4" stroke="currentColor" stroke-width="2"/>
              <path d="M4 7L4 4L7 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div class="stat-content">
              <span class="stat-label">Intentos</span>
              <span class="stat-value">
                @if (examen()!.intentos_permitidos === 0) {
                  Ilimitados
                } @else {
                  {{ intentosRealizados() }} / {{ examen()!.intentos_permitidos }}
                }
              </span>
            </div>
          </div>
        </div>

        <!-- Advertencia de intento en progreso -->
        @if (intentoEnProgreso()) {
          <div class="warning-box">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10 6V10M10 14H10.01M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z" stroke="#FFB800" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <p>Tienes un intento sin finalizar. Al continuar, retomarás ese intento.</p>
          </div>
        }

        <!-- Advertencia sin intentos -->
        @if (!intentosDisponibles()) {
          <div class="error-box">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10 6V10M10 14H10.01M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z" stroke="#DC3D1A" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <p>Ya has utilizado todos tus intentos disponibles para este examen.</p>
          </div>
        }

        <div class="instructions-content">
          <h2>Instrucciones</h2>
          <ul class="instructions-list">
            <li>Lee cuidadosamente cada pregunta antes de responder</li>
            <li>Puedes navegar entre las preguntas usando los botones de navegación</li>
            <li>Tus respuestas se guardan automáticamente</li>
            @if (examen()!.tiempo_limite && examen()!.tiempo_limite > 0) {
              <li>El examen se enviará automáticamente cuando se agote el tiempo</li>
            }
            <li>Asegúrate de tener una conexión estable a internet</li>
            <li>Una vez finalizado, no podrás modificar tus respuestas</li>
          </ul>
        </div>

        <div class="info-box-helper">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="10" r="8" stroke="#0e40d8" stroke-width="2"/>
            <path d="M10 9V13M10 6H10.01" stroke="#0e40d8" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <div>
            <strong>¿Ves preguntas repetidas?</strong>
            <p>Si tienes problemas visualizando preguntas duplicadas, <a [href]="'/exam/test/' + examen()!.id_examen" class="link-helper">haz clic aquí</a> para usar el visualizador completo.</p>
          </div>
        </div>

        <button 
          class="btn-start-exam" 
          [disabled]="!intentosDisponibles()"
          (click)="iniciarExamen()">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M5 3L15 10L5 17V3Z" fill="currentColor"/>
          </svg>
          @if (intentoEnProgreso()) {
            Continuar Examen
          } @else {
            Iniciar Examen
          }
        </button>
      </div>
    </div>
  }

  <!-- Pantalla del examen en progreso -->
  @else if (examenIniciado() && examen() && !examenFinalizado() && !mostrandoResultados()) {
    <div class="exam-screen">
      <!-- Encabezado con timer -->
      <div class="exam-top-bar">
        <div class="exam-info-bar">
          <h2 class="exam-title-bar">{{ examen()!.titulo }}</h2>
          <span class="question-counter">
            Pregunta {{ currentQuestionIndex() + 1 }} de {{ examen()!.preguntas.length }}
          </span>
        </div>

        @if (examen()!.tiempo_limite && examen()!.tiempo_limite > 0) {
          <div class="timer" [class.warning]="tiempoRestante() < 300">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="2"/>
              <path d="M10 5V10L13 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <span class="timer-text">{{ formatTime(tiempoRestante()) }}</span>
          </div>
        }
      </div>

      <div class="exam-content">
        <!-- Sidebar de navegación de preguntas -->
        <aside class="questions-sidebar">
          <h3 class="sidebar-title">Preguntas</h3>
          <div class="questions-grid">
            @for (pregunta of examen()!.preguntas; track pregunta.id_pregunta; let i = $index) {
              <button 
                class="question-nav-btn"
                [class.active]="i === currentQuestionIndex()"
                [class.answered]="isPreguntaRespondida(pregunta.id_pregunta)"
                (click)="irAPregunta(i)">
                {{ i + 1 }}
              </button>
            }
          </div>

          <div class="progress-summary">
            <div class="progress-circle">
              <svg viewBox="0 0 36 36" class="circular-chart">
                <path class="circle-bg"
                  d="M18 2.0845
                    a 15.9155 15.9155 0 0 1 0 31.831
                    a 15.9155 15.9155 0 0 1 0 -31.831"
                />
                <path class="circle"
                  [attr.stroke-dasharray]="(respuestas.size / examen()!.preguntas.length * 100) + ', 100'"
                  d="M18 2.0845
                    a 15.9155 15.9155 0 0 1 0 31.831
                    a 15.9155 15.9155 0 0 1 0 -31.831"
                />
                <text x="18" y="20.35" class="percentage">{{ respuestas.size }}</text>
              </svg>
            </div>
            <p class="progress-text">
              {{ respuestas.size }} de {{ examen()!.preguntas.length }} respondidas
            </p>
          </div>
        </aside>

        <!-- Área principal de la pregunta -->
        <main class="question-main">
          @if (examen()!.preguntas[currentQuestionIndex()]; as pregunta) {
            <div class="question-card">
              <div class="question-header">
                <span class="question-number">Pregunta {{ currentQuestionIndex() + 1 }}</span>
                @if (pregunta.obligatoria) {
                  <span class="required-badge">Obligatoria</span>
                }
                <span class="question-points">{{ pregunta.puntos }} punto(s)</span>
              </div>

              <div class="question-content">
                <h3 class="question-text">{{ pregunta.texto_pregunta }}</h3>
                
                @if (pregunta.imagen_url) {
                  <div class="question-image">
                    <img [src]="pregunta.imagen_url" [alt]="'Imagen pregunta ' + (currentQuestionIndex() + 1)">
                  </div>
                }

                <!-- Opciones de respuesta según el tipo de pregunta -->
                <div class="options-container">
                  @if (pregunta.tipo_pregunta === 'opcion_multiple' || pregunta.tipo_pregunta === 'verdadero_falso') {
                    @for (opcion of pregunta.opciones; track opcion.id_opcion) {
                      <label class="option-label" [class.selected]="getRespuesta(pregunta.id_pregunta)?.id_opcion === opcion.id_opcion">
                        <input 
                          type="radio" 
                          [name]="'pregunta_' + pregunta.id_pregunta"
                          [value]="opcion.id_opcion"
                          [checked]="getRespuesta(pregunta.id_pregunta)?.id_opcion === opcion.id_opcion"
                          (change)="guardarRespuesta(pregunta, opcion.id_opcion)">
                        <span class="option-text">{{ opcion.texto_opcion }}</span>
                        <span class="checkmark"></span>
                      </label>
                    }
                  }

                  @if (pregunta.tipo_pregunta === 'seleccion_multiple') {
                    <p class="selection-hint">Selecciona la opción correcta</p>
                    @for (opcion of pregunta.opciones; track opcion.id_opcion) {
                      <label class="option-label" [class.selected]="getRespuesta(pregunta.id_pregunta)?.id_opcion === opcion.id_opcion">
                        <input 
                          type="radio" 
                          [name]="'pregunta_' + pregunta.id_pregunta"
                          [value]="opcion.id_opcion"
                          [checked]="getRespuesta(pregunta.id_pregunta)?.id_opcion === opcion.id_opcion"
                          (change)="guardarRespuesta(pregunta, opcion.id_opcion)">
                        <span class="option-text">{{ opcion.texto_opcion }}</span>
                        <span class="checkmark"></span>
                      </label>
                    }
                  }

                  @if (pregunta.tipo_pregunta === 'respuesta_corta') {
                    <textarea 
                      class="text-answer"
                      rows="3"
                      placeholder="Escribe tu respuesta aquí..."
                      [value]="getRespuesta(pregunta.id_pregunta)?.respuesta_texto || ''"
                      (input)="guardarRespuesta(pregunta, undefined, $any($event.target).value)">
                    </textarea>
                  }

                  @if (pregunta.tipo_pregunta === 'respuesta_larga') {
                    <textarea 
                      class="text-answer large"
                      rows="8"
                      placeholder="Desarrolla tu respuesta de forma completa..."
                      [value]="getRespuesta(pregunta.id_pregunta)?.respuesta_texto || ''"
                      (input)="guardarRespuesta(pregunta, undefined, $any($event.target).value)">
                    </textarea>
                  }
                </div>
              </div>

              <!-- Navegación entre preguntas -->
              <div class="question-navigation">
                <button 
                  class="btn-nav" 
                  [disabled]="currentQuestionIndex() === 0"
                  (click)="anteriorPregunta()">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M12 16L6 10L12 4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                  Anterior
                </button>

                @if (currentQuestionIndex() < examen()!.preguntas.length - 1) {
                  <button 
                    class="btn-nav btn-next" 
                    (click)="siguientePregunta()">
                    Siguiente
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M8 4L14 10L8 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                  </button>
                } @else {
                  <button 
                    class="btn-finish" 
                    (click)="confirmarFinalizarExamen()">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M16 6L8 14L4 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                    Finalizar Examen
                  </button>
                }
              </div>
            </div>
          }
        </main>
      </div>
    </div>
  }

  <!-- Pantalla de resultados -->
  @else if (mostrandoResultados() && resultados()) {
    <div class="results-screen">
      <div class="results-card">
        <div class="results-icon" [class.passed]="resultados().aprobado" [class.failed]="!resultados().aprobado">
          @if (resultados().aprobado) {
            <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
              <circle cx="40" cy="40" r="38" fill="#77d27a"/>
              <path d="M25 40L35 50L55 30" stroke="white" stroke-width="4" stroke-linecap="round"/>
            </svg>
          } @else {
            <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
              <circle cx="40" cy="40" r="38" fill="#DC3D1A"/>
              <path d="M30 30L50 50M50 30L30 50" stroke="white" stroke-width="4" stroke-linecap="round"/>
            </svg>
          }
        </div>

        <h1 class="results-title">
          @if (resultados().aprobado) {
            ¡Felicitaciones!
          } @else {
            No aprobaste
          }
        </h1>

        <p class="results-subtitle">
          @if (resultados().aprobado) {
            Has aprobado el examen exitosamente
          } @else {
            No alcanzaste la nota mínima requerida
          }
        </p>

        <div class="results-stats">
          <div class="result-stat">
            <span class="result-label">Puntuación</span>
            <span class="result-value">{{ resultados().porcentaje }}%</span>
          </div>
          <div class="result-stat">
            <span class="result-label">Puntos obtenidos</span>
            <span class="result-value">{{ resultados().puntuacion }} / {{ resultados().puntuacion_maxima }}</span>
          </div>
          <div class="result-stat">
            <span class="result-label">Tiempo total</span>
            <span class="result-value">{{ formatTime(resultados().tiempo_total || 0) }}</span>
          </div>
        </div>

        <button class="btn-back-course" (click)="goBack()">
          Volver al Curso
        </button>
      </div>
    </div>
  }

  <!-- Diálogo de confirmación para finalizar -->
  @if (showConfirmDialog()) {
    <div class="dialog-overlay" (click)="cancelarFinalizar()">
      <div class="dialog-card" (click)="$event.stopPropagation()">
        <h3 class="dialog-title">¿Finalizar examen?</h3>
        <p class="dialog-message">
          ¿Estás seguro de que deseas finalizar el examen? No podrás modificar tus respuestas después.
        </p>
        <div class="dialog-actions">
          <button class="btn-dialog btn-cancel" (click)="cancelarFinalizar()">
            Cancelar
          </button>
          <button class="btn-dialog btn-confirm" (click)="finalizarExamen()">
            Finalizar
          </button>
        </div>
      </div>
    </div>
  }
</div>

